import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MarketAirProductsModel } from 'src/app/models/air/market-air-products.model';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';

@Pipe({
  name: 'hasPrice'
})
@Injectable({
  providedIn: 'root'
})
export class ProductHasPricePipe implements PipeTransform {
  transform(
    item: MarketSeaProductsModel | MarketAirProductsModel | null | undefined, 
    model: any, 
    transportType: 'sea' | 'air'
  ): boolean {
    
    if (!item || !item.freights || !model) {
      return false;
    }

    let hasPriceLogic = false;

    if (transportType === 'sea') {
      const hasNoErrors     = !item.freights.errorCode && !model.isNoPrice;
      const hasValue        = !!item.freights.grandTotal;

      hasPriceLogic =  hasNoErrors && hasValue;
    } 
    
    else if (transportType === 'air') {
      const hasNoErrors     = !item.freights.errorCode && !model.isNoPrice;
      const hasValue        = !!item.freights.grandTotal;
      const hasCapacity     = !!item.availableCapacity;

      hasPriceLogic =  hasNoErrors && hasValue && hasCapacity;
    }

    const unitPrice = item.freights.unitPrice;
    const priceOk = unitPrice != null && unitPrice !== 0;

    return hasPriceLogic && priceOk;
  }
}